module.exports = __webpack_public_path__ + "img/citylink.aae15461.jpg";